module.exports = __webpack_public_path__ + "static/media/redLock.6ecf478c.svg";